export const resources = {
  Close: ''
};
